import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class DeliveryPartnersServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/deliverypartners/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }

     getallDeliveryPartnerConfiguration(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-delivery-partners-data/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    updateDeliveryPartnersStatusById(data) {
        return this.http.post(`${this.backendUrl}${this.api}update-deliverypartners-status/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    deleteDeliveryPartnersConfigurationById(data) {
        return this.http.post(`${this.backendUrl}${this.api}delete-deliverypartners-data/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    getDeliveryPartnerConfigurationByID(rest_id:any,id:any) {
        return this.http.get(`${this.backendUrl}${this.api}delivery-partners-id/${rest_id}/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallPartnerChargingRuleConfig(rest_id:any,br_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-partner-change-rule/${rest_id}/${br_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdateDeliveryMappingData(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-partner/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdateDeliveryMappingDataQuesttag(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-partner-questtag/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    deletePartnerMappingById(data) {
        return this.http.post(`${this.backendUrl}${this.api}delete-partner-questtag/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    getallDeliveryPartnersName() {
        return this.http.get(`${this.backendUrl}${this.api}get-partners-name/` , this.jwt_new()).map(response => response.json());
    }

    getMappedAllBranches(id:any,pt_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-mapped-branches/${id}/${pt_id}` , this.jwt_new()).map(response => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/deliverypartners.service.ts